<ca-modal-container
    data-uit="active-workflows-dialog"
    modalTitle="{{ 'WORKFLOWS.RUNNER.DIALOG.ACTIVE_WORKFLOWS.TITLE' | translate }}"
    (dismiss)="dismiss()"
    description=""
>
    <ca-table>
        <thead>
            <tr>
                <th>{{ 'GENERAL.COLUMN.NAME' | translate }}</th>
                <th>{{ 'GENERAL.COLUMN.STARTED' | translate }}</th>
                <th>{{ 'GENERAL.COLUMN.RUN_MODE' | translate }}</th>
                <th>{{ 'GENERAL.COLUMN.ACTIONS' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let groupedRow of groupedRows">
                <tr class="group-header-row" (click)="groupedRow.expanded = !groupedRow.expanded">
                    <th colspan="4" class="has-expand-icon">
                        <span>{{ groupedRow.header.title }}</span>
                        <ca-table-expand-icon [(expanded)]="groupedRow.expanded" (click)="groupedRow.expanded = !groupedRow.expanded"></ca-table-expand-icon>
                    </th>
                </tr>
                <tr
                    *ngFor="let row of groupedRow.children"
                    [hidden]="!groupedRow.expanded"
                    class="group-child-row"
                    data-uit="active-workflows-dialog-modal-workflow-row"
                >
                    <td [ngClass]="{ clickable: isClickable(row) }" (click)="jumpIntoRunner(row)">
                        <a class="ms-2 runner-link" *ngIf="row.workflowType === 'Undefined'" data-uit="active-workflow-name">{{ row.workflowTitle }}</a>
                        <span class="ms-2" *ngIf="row.workflowType !== 'Undefined'">
                            {{ row.workflowTitle }}
                        </span>
                    </td>
                    <td [ngClass]="{ clickable: isClickable(row) }" (click)="jumpIntoRunner(row)">
                        <div *ngIf="!row.executedAt" class="d-flex align-items-center">
                            <span class="pending">Pending</span><ca-icon name="clock" size="s" class="ms-2"></ca-icon>
                        </div>
                        <span *ngIf="row.executedAt" data-uit="active-workflows-dialog-modal-workflow-executedAt">{{ row.executedAt | resultDate }}</span>
                    </td>
                    <td [ngClass]="{ clickable: isClickable(row) }" (click)="jumpIntoRunner(row)">
                        <span class="ms-2" data-uit="active-workflow-is-step-by-step">{{ getRunModeText(row.isInteractiveWorkflow) }}</span>
                    </td>
                    <td>
                        <ca-action-buttons [buttons]="buttons" [item]="row"></ca-action-buttons>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </ca-table>
</ca-modal-container>
